export default {
    title: 'Analytics Reports',
    create: 'Create Report',
    icon: 'Icon',
    'report-name': 'Report Name',
    widgets: 'Widgets',
    'add-widget': 'Add widget',
    'widget-types': {
        insight: {
            'default-name': 'Insight',
            table: 'Table',
            metric: 'Metric',
            field: 'Metric field',
            visualization: 'Visualization',
            filter: 'Filter',
            'group-by': 'Group by field',
            'segment-by': 'Segment by field',
            metrics: {
                count: 'Count',
                avg: 'Average',
                sum: 'Sum',
                min: 'Minimum',
                max: 'Maximum',
            },
            visualizations: {
                single_metric: 'Single Metric',
                pie: 'Pie Chart',
                bar: 'Bar Chart',
                line: 'Line Chart',
            },
            'stacked-bars': 'Stacked Bars',
            'series-sort': 'Series Sort',
            'sort-by-name': 'By Name',
            'sort-by-value': 'By Value',
            threshold: 'Threshold',
            'show-empty-values': '└ Show empty values',
            'date-granularity': '└ Date granularity',
            'multi-value-mode': '└ Multi-value mode',
            'date-granularity-options': {
                day: 'Day',
                week: 'Week',
                month: 'Month',
                quarter: 'Quarter',
                year: 'Year',
            },
            'multi-value-mode-options': {
                expand: 'Expand',
                combine: 'Combine',
            },
            labels: {
                unknown: 'Unknown',
                'no-value': '(no value)',
            },
            errors: {
                'name-missing': 'Widget name is required',
                'table-id-missing': 'Table selection is required',
                'metric-field-id-missing': 'Metric field is required',
            },
        },
    },
    'widget-name': 'Widget name',
    refresh: 'Refresh',
    'show-underlying-data': 'Show underlying data',
    'underlying-data': 'Underlying data for widget',
}
